import { render, staticRenderFns } from "./menuManagement.vue?vue&type=template&id=521ce620&scoped=true"
import script from "./menuManagement.vue?vue&type=script&lang=js"
export * from "./menuManagement.vue?vue&type=script&lang=js"
import style0 from "./menuManagement.vue?vue&type=style&index=0&id=521ce620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ce620",
  null
  
)

export default component.exports